export default "__VITE_ASSET__DOlSX51H__"